import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  ControlLabel,
  HelpBlock,
  FormControl,
  Alert
} from 'react-bootstrap';
import { find, prop, equals } from 'ramda';
import questionTypes from '../questionTypes.json';
import styles from './TextQuestion.css';

TextInputQuestion.propTypes = {
  questionId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  unit: PropTypes.string,
  help: PropTypes.string,
  options: PropTypes.array.isRequired,
  answers: PropTypes.array,
  onAnswer: PropTypes.func,
  readOnly: PropTypes.bool,
  showValidation: PropTypes.bool,
  validationState: PropTypes.string
};

const getAnswerId = prop('answerId');
const findAnswerForOption = option =>
  find(answer => equals(getAnswerId(option), getAnswerId(answer)));

const renderTextArea = (
  value,
  isReadOnly,
  option,
  questionId,
  onAnswer,
  questionType
) => {
  if (isReadOnly) {
    return <div className={styles['review-mode']}>{value}</div>
  }
  return <FormControl
    componentClass="textarea"
    disabled={isReadOnly}
    placeholder={option.text}
    value={value}
    onChange={event =>
      onAnswer(
        questionId,
        questionType,
        option.answerId,
        event.target.value
      )}
  />
};

function TextInputQuestion({
  questionId,
  text,
  help,
  unit,
  answers,
  options,
  onAnswer,
  readOnly,
  showValidation,
  validationState = null
}) {
  const option = options[0];
  const answer = findAnswerForOption(option)(answers);
  const value = answer ? prop('value')(answer) : '';
  const textArea = renderTextArea(
    value,
    readOnly,
    option,
    questionId,
    onAnswer,
    questionTypes.text
  );

  return (
    <FormGroup controlId={questionId} validationState={validationState}>
      <ControlLabel>
        {text}
      </ControlLabel>
      {textArea}
      {help &&
        showValidation && (
          <HelpBlock>
            <Alert bsStyle="danger">{help}</Alert>
          </HelpBlock>
        )}
    </FormGroup>
  );
}

export default TextInputQuestion;



// WEBPACK FOOTER //
// ./src/components/questions/TextQuestion/TextQuestion.js